import * as React from "react";
const SvgFiRrUiUx = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-ui-ux_svg__a)">
      <path
        fill="#062147"
        d="M24 12a1 1 0 0 1-1 1H1a1 1 0 1 1 0-2h22a1 1 0 0 1 1 1m-7 3a1 1 0 0 0-1 1v7a1 1 0 1 0 2 0v-7a1 1 0 0 0-1-1m-4 0a1 1 0 0 0-1 1v4c0 1.103-.897 2-2 2s-2-.897-2-2v-4a1 1 0 1 0-2 0v4c0 2.206 1.794 4 4 4s4-1.794 4-4v-4a1 1 0 0 0-1-1M8 9c2.206 0 4-1.794 4-4V1a1 1 0 1 0-2 0v4c0 1.103-.897 2-2 2s-2-.897-2-2V1a1 1 0 1 0-2 0v4c0 2.206 1.794 4 4 4m6.504-.132a.998.998 0 0 0 1.364-.372L17 6.515l1.132 1.98a.999.999 0 1 0 1.736-.991L18.152 4.5l1.716-3.004a1 1 0 0 0-1.736-.992L17 2.484 15.868.505a1 1 0 0 0-1.736.992L15.848 4.5l-1.716 3.004a1 1 0 0 0 .372 1.364"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-ui-ux_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrUiUx;
